import React, { useState, useRef, useEffect } from 'react';
import { Calendar, ChevronLeft, ChevronRight } from 'lucide-react';

const YearPicker = ({ value, onChange, minYear = 1900, maxYear = new Date().getFullYear() + 5 }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [decade, setDecade] = useState(Math.floor((value || new Date().getFullYear()) / 10) * 10);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const years = [];
  for (let i = 0; i < 10; i++) {
    years.push(decade + i);
  }

  const handlePrevDecade = () => {
    setDecade(decade - 10);
  };

  const handleNextDecade = () => {
    setDecade(decade + 10);
  };

  const handleYearClick = (year) => {
    onChange(year);
    setIsOpen(false);
  };

  const isYearDisabled = (year) => {
    return year < minYear || year > maxYear;
  };

  return (
    <div className="relative" ref={dropdownRef}>
      <div className="relative">
        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          <Calendar className="h-5 w-5 text-blue-600" />
        </div>
        <input
          type="text"
          className="pl-10 w-full rounded-lg border border-gray-300 bg-white py-2 text-gray-900 outline-none focus:border-blue-600 focus:ring-1 focus:ring-blue-600 cursor-pointer"
          value={value || ''}
          onClick={() => setIsOpen(true)}
          readOnly
          placeholder="Select year"
        />
      </div>

      {isOpen && (
        <div className="absolute z-50 mt-1 w-full bg-white rounded-lg shadow-lg border border-gray-200">
          <div className="p-2">
            <div className="flex justify-between items-center mb-2">
              <button
                onClick={handlePrevDecade}
                className="p-1 hover:bg-gray-100 rounded-full"
                type="button"
              >
                <ChevronLeft className="h-5 w-5 text-gray-600" />
              </button>
              <span className="text-sm font-medium text-gray-700">
                {decade} - {decade + 9}
              </span>
              <button
                onClick={handleNextDecade}
                className="p-1 hover:bg-gray-100 rounded-full"
                type="button"
              >
                <ChevronRight className="h-5 w-5 text-gray-600" />
              </button>
            </div>

            <div className="grid grid-cols-3 gap-1">
              {years.map((year) => (
                <button
                  key={year}
                  onClick={() => !isYearDisabled(year) && handleYearClick(year)}
                  className={`
                    py-2 px-3 text-sm rounded-md transition-colors
                    ${value === year ? 'bg-blue-100 text-blue-700 font-medium' : 'hover:bg-gray-100'}
                    ${isYearDisabled(year) ? 'text-gray-300 cursor-not-allowed' : 'text-gray-700 cursor-pointer'}
                  `}
                  disabled={isYearDisabled(year)}
                  type="button"
                >
                  {year}
                </button>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default YearPicker;